import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/tokens.css';
import './styles/base.css';

const container = document.getElementById('root');
if (!container) throw new Error('ไม่พบ #root ใน index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// ลงทะเบียน service worker เพื่อให้เปิดหน้าหลักได้เมื่อสัญญาณไม่เสถียร
// ไม่ทำใน dev เพราะ SW จะ cache ไฟล์เก่าค้างจน hot reload ไม่ทำงาน
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' });
  });
}
